<template>
    <div class="content">
        <div class="header-main">
            <div class="promote-info">
                <span class="hedlyner-text"
                    >HEDLYNER —<br />
                    Music Booking <br />
                    Made Easy</span
                >
                <span class="hedlyner-play">
                    Book more. Play more. Keep track of everything. All in one place.</span
                >
                <div class="header-btn">
                    <button v-if="!authed" class="acc-create-btn" @click="goToLogIn()">
                        <span class="acc-create-text">Create account</span>
                    </button>
                    <button class="explore-btn">
                        <a href="#artist-content" class="explore-btn-text">Explore tools</a>
                    </button>
                </div>
            </div>
        </div>
        <div class="hedlyner-goals">
            <span class="goals-text">We have one goal. Inspire live music.</span>
            <span class="goals-text-lil">
                Founded by music lovers and event producers, we know the importance that live
                shows play in providing a financial safety net for musicians, revenue streams
                for bookers and a rewarding audience experience.
            </span>
        </div>
        <div id="artist-content" class="hedl-for-artists">
            <div class="image-content" v-if="width >= 900">
                <img class="img-fluid" :src="getImage() + 'maj-pic.png'" alt="maj" />
            </div>
            <div class="text-side-header">
                <div class="artist-content-top">
                    <span class="for-artist">Hedlyner <br />for Artists</span>
                    <span class="artist-find">
                        Find new opportunities. Book shows. Get paid. No headaches. Only
                        headbangers.
                    </span>
                    <button class="artist-find-btn" @click="toggleArtistPage()">
                        <span class="artist-find-text">Explore Artist Tools</span>
                    </button>
                </div>
                <div class="artist-story">
                    <div class="image-content" v-if="width < 900">
                        <img class="img-fluid" :src="getImage() + 'maj-pic.png'" alt="" />
                    </div>
                    <transition name="fade">
                        <div class="comment-container" :key="artistComment.id">
                            <div class="comment">
                                <p
                                    v-for="(line, indx) in artistComment.texts"
                                    :key="indx"
                                    class="artist-comment"
                                >
                                    {{ line }}
                                </p>
                            </div>
                            <span class="artist-comment">
                                —
                                {{ `${artistComment.author}, ${artistComment.company}` }}
                            </span>
                        </div>
                    </transition>
                    <div v-if="artistComment.length > 1" class="pagination">
                        <div
                            v-for="(comment, paginationIndx) in artistComments"
                            :key="paginationIndx"
                            :class="paginationClass(paginationIndx, 'artistCommentIndx')"
                            @click="updateIndx(paginationIndx, 'artistCommentIndx')"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pad-div" v-if="width >= 900"></div>
        <div class="info-venues">
            <div class="for-bookers">
                <div class="top-text-venue">
                    <span class="venue-text"
                        >Hedlyner <br />
                        for Bookers</span
                    >
                    <span class="venue-text-small"
                        >Discover artists. Book events. Message talent. Manage it all in one
                        place. Whether you're a promoter, venue, or just hosting a private
                        event, we've got everything you need.</span
                    >
                    <button class="explore-venue-btn" @click="toggleVenuePage()">
                        <span class="artist-find-text"> Explore Booker Tools </span>
                    </button>
                </div>
                <div class="venue-story">
                    <div class="venue-img" v-if="width < 900">
                        <img
                            class="img-fluid"
                            :src="getImage() + 'main-page-pic.png'"
                            alt=""
                        />
                    </div>
                    <transition name="fade">
                        <div class="comment-container" :key="venueComment.id">
                            <div class="comment">
                                <span
                                    v-for="indx in venueComment.texts"
                                    :key="indx"
                                    class="venue-comment"
                                >
                                    {{ indx }}
                                </span>
                            </div>
                            <span class="venue-comment">
                                —
                                {{
                                    `${venueComment.author}, owner of ${venueComment.company}`
                                }}
                            </span>
                        </div>
                    </transition>
                    <div v-if="artistComment.length > 1" class="pagination">
                        <div
                            v-for="(comment, indx) in venueComments"
                            :key="indx"
                            @click="updateIndx(indx, 'venueCommentIndx')"
                            :class="paginationClass(indx, 'venueCommentIndx')"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="venue-img" v-if="width >= 900">
                <img class="img-fluid" :src="getImage() + 'main-page-pic.png'" alt="" />
            </div>
        </div>
        <div v-if="authed" class="bottom-spacer"></div>
        <div v-if="!authed" class="start-wrapper">
            <div class="get-started">
                <span class="start-head">Get Started for Free</span>
                <span class="start-head-small"
                    >Hedlyner is free to start using! <br />
                    <span class="hedl-basic">Hedlyner Basic</span> covers everything you need
                    to get started <br />
                    finding shows and booking artists. Need more tools down <br />
                    the line? Just upgrade as you go.</span
                >
            </div>
        </div>
        <div v-if="!authed" class="subscr-plans">
            <div class="sub-for-artist">
                <div class="sub-header">
                    <p class="sub-art-header">For Artists</p>
                    <p class="sub-artist-header-small">
                        Free forever, Plus 8% Commission for Confirmed Bookings
                    </p>
                </div>
                <div class="features-list">
                    <span class="feature-head">Features:</span>
                    <div class="sub-point-name">
                        <img src="/images/global/icon-yes-art.png" alt="/" />
                        <span class="free-artist-sub">Booking Manager Pro</span>
                    </div>
                    <ul class="sub-list">
                        <li
                            v-for="(points, index) in subPlansArtist[0].listOfPlanFeatures
                                .subPointsList"
                            :key="index"
                        >
                            <div class="sub-tooltip">{{ points.tooltip }}</div>
                            <img
                                :src="points.subStatus ? getYellowYesIcon : getYellowNoIcon"
                                alt="/"
                            /><span
                                :style="{ color: points.subStatus ? '#DEDEDE' : '#646464' }"
                                class="free-artist-sub"
                                >{{ points.SubPoint }}</span
                            >
                        </li>
                    </ul>
                    <div class="sub-point-name">
                        <img src="/images/global/icon-yes-art.png" alt="/" />
                        <span class="free-artist-sub">Account Management</span>
                    </div>

                    <ul class="sub-list">
                        <li
                            v-for="(points, index) in subPlansArtist[0].listOfPlanFeatures
                                .ManagePointsList"
                            :key="index"
                        >
                            <div class="sub-tooltip">{{ points.tooltip }}</div>
                            <img
                                :src="points.manageStatus ? getYellowYesIcon : getYellowNoIcon"
                            /><span
                                :style="{ color: points.manageStatus ? '#DEDEDE' : '#646464' }"
                                class="free-artist-sub"
                                >{{ points.ManagePoint }}</span
                            >
                        </li>
                    </ul>
                </div>
                <div class="artist-sub-footer">
                    <button class="artist-sub-btn" @click="goToLogIn()">
                        <span class="artist-find-text">Create account</span>
                    </button>
                </div>
            </div>
            <div class="sub-for-venue">
                <div class="sub-header">
                    <p class="sub-ven-header">For Bookers</p>
                    <div class="sub-artist-header-small">Free forever, plus booking fees</div>
                </div>
                <div class="features-list">
                    <span class="feature-head purple-text">Features:</span>
                    <div class="sub-point-name">
                        <img :src="getPurpleYesIcon" alt="/" />
                        <span class="free-artist-sub">Booking Manager Lite</span>
                    </div>
                    <ul>
                        <li
                            v-for="(point, index) in subPlans[0].listOfPlanFeatures
                                .subPointsList"
                            :key="index"
                        >
                            <div class="sub-tooltip">{{ point.tooltip }}</div>
                            <img :src="getPurpleYesIcon" alt="/" /><span
                                class="free-artist-sub"
                                >{{ point.SubPoint }}</span
                            >
                        </li>
                    </ul>
                    <div class="sub-point-name">
                        <img :src="getPurpleYesIcon" alt="/" />
                        <span class="free-artist-sub">Talent Management</span>
                    </div>
                    <ul>
                        <li
                            v-for="(point, index) in subPlans[0].listOfPlanFeatures
                                .TalentPointsList"
                            :key="index"
                        >
                            <div class="sub-tooltip">{{ point.tooltip }}</div>
                            <img :src="getPurpleYesIcon" alt="/" /><span
                                class="free-artist-sub"
                                >{{ point.TalentPoint }}</span
                            >
                        </li>
                    </ul>
                </div>
                <div class="artist-ven-footer">
                    <button class="venue-sub-btn" @click="redirectToVenueReg">
                        <span class="artist-find-text">Create account</span>
                    </button>
                    <button @click="redirectVenuePlans" class="artist-sub-exp">
                        <span><u>Explore Other Tiers</u></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import checkScreen from '../../mixins/check-screen'
    import { SubMixin } from '@/mixins/subscription/subscriptions'
    import { useAuth } from '@/composables/auth/useAuth'
    import { api } from '@/helpers/api'

    const URLS = {
        xhr: {
            checkAuth: '/check-authorization',
            user: '/profile/v1/settings/user'
        }
    }

    export default {
        name: 'HomePage',
        mixins: [checkScreen, SubMixin],
        setup() {
            const { handleShowRegisterModal } = useAuth()

            return {
                handleShowRegisterModal
            }
        },
        data: () => ({
            freeSubsForArtist: {
                subPointsList: [
                    {
                        SubPoint: 'Manage Unlimited Gigs',
                        subStatus: true,
                        tooltip:
                            'Book as many shows as you want. Keep track of them all in one place.'
                    },
                    {
                        SubPoint: 'Streamline Booking',
                        subStatus: true,
                        tooltip: 'Make offers, negotiate rates, accept bookings.'
                    },
                    {
                        SubPoint: 'Discover new opportunites',
                        subStatus: true,
                        tooltip: 'Easily search for all open events in your area. '
                    },
                    {
                        SubPoint: '10% In-App Booking Fee',
                        subStatus: true,
                        tooltip:
                            'Hedlyner`s commission rate is deducted from the booking rate before it`s deposited in your account.'
                    },
                    {
                        SubPoint: 'Show Promotion Tools',
                        subStatus: true,
                        tooltip:
                            'Share beautifully created event pages with just the click of a button, if available from venue.'
                    },
                    {
                        SubPoint: 'Direct Payments',
                        subStatus: true,
                        tooltip: 'Get paid automatically as soon as the show is over.'
                    },
                    {
                        SubPoint: 'Reviews and Ratings',
                        subStatus: true,
                        tooltip:
                            'Share feedback with your community. Learn from your peers. Standout for being on your game.'
                    },
                    {
                        SubPoint: 'Share Avails',
                        subStatus: false,
                        tooltip:
                            'Wanna be proactive? Share your availability with venues on your artist profile.'
                    },
                    {
                        SubPoint: 'Pre-Show Checks',
                        subStatus: false,
                        tooltip:
                            'Stay on track with automated reminders – set it and forget it.'
                    },
                    {
                        SubPoint: '0% Fee Offline Payments',
                        subStatus: false,
                        tooltip:
                            'Hedlyner waives commission fees for payments made outside the app.'
                    }
                ],
                ManagePointsList: [
                    {
                        ManagePoint: 'Contacts Manager',
                        manageStatus: false,
                        tooltip: 'Keep track of venues you`ve played in one centralized place.'
                    },
                    {
                        ManagePoint: 'One Artists Profile',
                        manageStatus: false,
                        tooltip:
                            'Sell yourself with your music, your vibe, your reach. All in one place.'
                    },
                    {
                        ManagePoint: 'One User Account',
                        manageStatus: false,
                        tooltip: 'One login to manage all your bookings.'
                    }
                ]
            },
            freeSubsForVenue: {
                subPointsList: [
                    {
                        SubPoint: 'Manage up to 5 Shows at the Same Time',
                        subStatus: true,
                        tooltip: 'Manage your shows from start to finish.'
                    },
                    {
                        SubPoint: 'Events Calendar',
                        subStatus: true,
                        tooltip:
                            'See what needs to get done with your personalized at-a-glance calendar.'
                    },
                    {
                        SubPoint: 'Check Avails',
                        subStatus: true,
                        tooltip:
                            'Share unique event links with your current roster, exclusive Hedlyner talent, or new artists off the street. '
                    },
                    {
                        SubPoint: 'Centralized Inbox',
                        subStatus: true,
                        tooltip:
                            'No more checking texts, emails, DMs, and voicemails. Get a smarter inbox. Make offers. Accept counteroffers. '
                    },
                    {
                        SubPoint: '5% In-App Booking Fee',
                        subStatus: true,
                        tooltip:
                            'The transaction fee is calculated based on the booking rate and added to the total amount debited from your account. For example,the total amount debited from your account for a $100 booking rate is $105. '
                    },
                    {
                        SubPoint: 'Pay with Credit Cards',
                        subStatus: true,
                        tooltip:
                            'Pay artists quickly through a trusted platform. Funds are released after the show.'
                    },
                    {
                        SubPoint: 'Event Wrap-up',
                        subStatus: true,
                        tooltip: 'Track payment management with the post-show payout summary.'
                    },
                    {
                        SubPoint: 'Reviews and Ratings',
                        subStatus: true,
                        tooltip: 'Share feedback with your community. Learn from your peers. '
                    }
                ],
                TalentPointsList: [
                    {
                        TalentPoint: 'Discover Artists',
                        manageStatus: true,
                        tooltip:
                            'Search for public artist profiles and quickly see who`s a good match. Listen to their music and see their reach all in one convenient place.'
                    },
                    {
                        TalentPoint: 'Artists Network',
                        manageStatus: true,
                        tooltip:
                            'Keep track of booked artists and new talent in one centralized place.'
                    }
                ],
                ManagePointList: [
                    {
                        ManagePoint: 'One Venue',
                        manageStatus: true,
                        tooltip: 'Showcase your venue with Venue Profiles.'
                    },
                    {
                        ManagePoint: 'One User Account',
                        manageStatus: true,
                        tooltip: 'One login to manage all your events.'
                    }
                ]
            },
            authed: false,
            userInfo: {},
            paginationTimer: null,
            paginationDuration: 5000,
            artistCommentIndx: 0,
            venueCommentIndx: 0,
            venueComments: [
                {
                    id: 0,
                    texts: [
                        "“Hedlyner's 360 approach to live event booking has streamlined my booking process so much that I am actually having to find new things to do with my time! But seriously, being able to share my calendar link with musicians walking in off the street, and have them submit themselves in such a uniform way, has really made finding new artists enjoyable again.”"
                    ],
                    author: 'Angela',
                    company: 'Happy Valley Filling Station'
                }
            ]
        }),
        methods: {
            toggleVenuePage() {
                window.location.href = '/for-bookers'
            },
            toggleArtistPage() {
                window.location.href = '/for-artists'
            },
            redirectArtistPlans() {
                window.location.href = '/for-artists#plans'
            },
            redirectVenuePlans() {
                window.location.href = '/for-bookers#plans'
            },
            getImage() {
                return '/images/global/'
            },
            getListIcons() {
                return '/images/global/Icons-yes.png'
            },
            goToLogIn() {
                this.handleShowRegisterModal()
            },
            redirectToVenueReg() {
                this.handleShowRegisterModal()
            },
            updateIndx(indx, prop) {
                this[prop] = indx
            },
            paginateComments() {
                let artistCommentsLen = this.artistComments.length
                let venueCommentsLen = this.venueComments.length

                if (this.artistCommentIndx === artistCommentsLen - 1) {
                    this.artistCommentIndx = 0
                } else {
                    this.artistCommentIndx = this.artistCommentIndx + 1
                }

                if (this.venueCommentIndx === venueCommentsLen - 1) {
                    this.venueCommentIndx = 0
                } else {
                    this.venueCommentIndx = this.venueCommentIndx + 1
                }
            },
            async checkAuth() {
                try {
                    const data = await api(
                        {
                            method: 'get',
                            url: this.URLS.xhr.checkAuth
                        },
                        { error: false }
                    )

                    this.authed = data.isAuthorized
                } catch {
                    this.authed = false
                }
            },
            async getUserSettings() {
                const data = await api({
                    method: 'get',
                    url: this.URLS.xhr.user
                })
                this.userInfo = data.data[0]
            }
        },
        computed: {
            artistComments: () => [
                {
                    id: 0,
                    texts: [
                        `“I'm honored to be working with a company whose primary goal is to create more opportunities for artists, bookers, and fans, to share more magic moments through live events.”`
                    ],
                    author: 'Maj',
                    company: 'San Francisco'
                }
            ],
            getYellowYesIcon() {
                return '/images/global/icon-yes-art.png'
            },
            getPurpleYesIcon() {
                return '/images/global/Icons-yes.png'
            },
            getYellowNoIcon() {
                return '/images/global/icon-no-art.png'
            },
            URLS: () => URLS,
            paginationClass: (self) => (indx, prop) => {
                let _class = { 'comment-pagination': true }

                if (self[prop] === indx) {
                    _class['current-comment'] = true
                }
                return _class
            },
            artistComment: (self) =>
                self.artistComments.find((c) => c.id === self.artistCommentIndx),
            venueComment: (self) =>
                self.venueComments.find((c) => c.id === self.venueCommentIndx)
        },
        async created() {
            await this.checkAuth()
            if (this.authed) await this.getUserSettings()
        },
        mounted() {
            this.paginationTimer = setInterval(() => {
                this.paginateComments()
            }, this.paginationDuration)
        },
        beforeDestroy() {
            clearInterval(this.paginationTimer)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .purple-text {
        color: #ba87ff !important;
    }
    .fade-enter {
        opacity: 0;
        position: absolute;
    }

    .fade-enter-active {
        transition: opacity 0.75s ease-out;
    }
    .fade-leave-active {
        transition: opacity 0.75s ease-out;
    }
    .fade-leave-to {
        opacity: 0;
        position: absolute;
    }

    .image-content {
        flex: 0 1 57%;
    }
    ul {
        margin-top: 15px;
        width: 100%;
    }
    li {
        margin-bottom: 15px;
        list-style-type: none;
        width: 100%;
        position: relative;
    }

    .sub-tooltip {
        display: none;
        position: absolute;
        bottom: 25px;
        background-color: #000;
        color: #dedede;
        padding: 10px 15px;
        max-width: 250px;
        border-radius: 10px;
        z-index: 1;
        font-size: 16px;
        transform: translateY(-10px);
        transition: opacity 0.3s ease, transform 0.3s ease;
    }
    .sub-tooltip::after {
        display: inline-block;
        content: '';
        position: absolute;
        background-color: #000;
        height: 15px;
        width: 15px;
        transform: translate(-50%, 100%) rotate(45deg); /* Добавлено translate(-50%, 100%) */
        -ms-transform: translate(-50%, 100%) rotate(45deg);
        -webkit-transform: translate(-50%, 100%) rotate(45deg);
        -o-transform: translate(-50%, 100%) rotate(45deg);
        -moz-transform: translate(-50%, 100%) rotate(45deg);
        left: 50%; /* Положение по горизонтали в 50% */
        bottom: 7px;
    }

    li:hover .sub-tooltip {
        display: block;
    }
    .bottom-spacer {
        height: 290px;
        background: black;
    }
    .content {
        display: flex;
        flex-direction: column;
    }
    .header-main {
        display: flex;
        flex-direction: column;
        background: url(/images/main-page-bg.png) no-repeat center / cover;
    }
    .hedlyner-text {
        color: #cdeb09;
        font-size: 72px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 525;
        line-height: 95%;
        letter-spacing: -4.32px;
    }
    .promote-info {
        display: flex;
        flex-direction: column;
        margin-top: 140px;
        margin-left: 90px;
        margin-bottom: 280px;
        max-width: 40%;
    }
    .hedlyner-play {
        color: #f5f5f5;
        font-size: 26px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
        margin: 30px 0;
    }
    .acc-create-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        border: none;
        margin-right: 15px;
    }
    .acc-create-text {
        color: #000000;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .explore-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        border: 1px solid #cdeb09;
        background: none;
    }
    .explore-btn-text {
        color: #cdeb09;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        text-decoration: none;
    }
    .hedlyner-goals {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 50px 0px;
        background: #cdeb09;
    }
    .goals-text {
        color: #262626;
        text-align: center;
        font-size: 44px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .goals-text-lil {
        color: #262626;
        text-align: center;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        max-width: 50%;
        padding-top: 20px;
    }
    .hedl-for-artists {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        background-size: cover;
        background: #000000;
        gap: 20px;
    }
    .text-side-header {
        display: flex;
        flex: 0 1 43%;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }
    .artist-content-top {
        display: flex;
        flex-direction: column;
    }
    .for-artist {
        color: #cdeb09;
        font-size: 56px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 100%;
        letter-spacing: -2.24px;
    }
    .artist-find {
        margin: 15px 0;
        color: #f5f5f5;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        max-width: 80%;
    }
    .artist-find-btn {
        display: flex;
        padding: 11px 50px 12px 50px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #cdeb09;
        margin-top: 15px;
        max-width: 65%;
        border: none;
    }
    .artist-find-text {
        color: #000000;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .artist-img {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .venue-img {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0 1 57%;
    }
    .img-fluid {
        min-width: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
    }
    .artist-story {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .venue-story {
        display: flex;
        margin-left: 75px;
        flex-direction: column;
        gap: 20px;
    }
    .comment {
        max-width: 513px;
    }
    .comment-container {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        gap: 20px;
    }
    .venue-comment,
    .artist-comment {
        margin-bottom: 0;
        color: #acacac;
        font-size: 22px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .pagination {
        display: flex;
        flex-direction: row;
        gap: 8px;
        flex-wrap: wrap;
        max-width: 270px;
    }
    .comment-pagination {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #acacac;
    }
    .comment-pagination.current-comment {
        opacity: 0.4;
    }
    .pad-div {
        background: #000;
        padding: 20px;
    }
    .info-venues {
        display: flex;
        flex-direction: row;
        background: #000000;
        padding-left: 90px;
    }
    .for-bookers {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        margin-right: 90px;
        flex: 0 1 43%;
    }
    .venue-text {
        color: #ba87ff;
        font-size: 56px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 100%;
        letter-spacing: -2.24px;
    }
    .venue-text-small {
        color: #f5f5f5;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        margin: 15px 0;
    }
    .explore-venue-btn {
        padding: 11px 50px 12px 50px;
        border-radius: 100px;
        background: #ba87ff;
        max-width: 65%;
        border: none;
    }
    .top-text-venue {
        display: flex;
        flex-direction: column;
    }
    .get-started {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: #000000;
        padding-top: 90px;
        margin: 0px 90px;
        border-top: 1px solid #acacac;
    }
    .start-head {
        color: #cdeb09;
        text-align: center;
        font-size: 72px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 100%;
        letter-spacing: -2.88px;
    }
    .start-wrapper {
        background: #000000;
        padding-top: 90px;
    }
    .start-head-small {
        padding-top: 20px;
        padding-bottom: 60px;
        color: #dedede;
        text-align: center;
        font-size: 22px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .hedl-basic {
        color: #cdeb09;
    }
    .subscr-plans {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        flex-wrap: wrap;
        gap: 30px;
        justify-content: center;
        padding-bottom: 150px;
        background: #000000;
    }
    .sub-for-artist {
        max-width: 407px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 24px;
        padding: 20px 25px 30px 25px;
        border-radius: 15px;
        background: #262626;
        flex: 0 0 30%;
    }
    .sub-for-venue {
        max-width: 407px;
        display: flex;
        flex-direction: column;
        padding: 20px 25px 30px 25px;
        justify-content: flex-start;
        gap: 24px;
        border-radius: 15px;
        background: #262626;
        flex: 0 0 30%;
        min-width: 407px;
        min-height: 724px;
    }
    .sub-art-header {
        color: #cdeb09;
        font-size: 32px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
        margin-bottom: 0;
    }
    .sub-ven-header {
        color: #ba87ff;
        font-size: 32px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
        margin-bottom: 0;
    }
    .sub-header {
        height: 106px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }
    .sub-artist-header-small {
        width: 100%;
        color: #8b8b8b;
        font-size: 16px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        padding-bottom: 15px;
        border-bottom: 1px solid #646464;
        margin-bottom: 0px;
        padding-top: 15px;
        padding-bottom: 8px;
    }
    .features-list {
        height: 505px;
    }
    .feature-head {
        color: #cdeb09;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .feature-ven-head {
        color: #ba87ff;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .sub-point-name {
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-start;
        margin-top: 10px;
    }
    .free-artist-sub {
        color: #dedede;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        margin-left: 10px;
    }
    .free-venue-sub {
        color: #dedede;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        margin-left: 10px;
    }
    .free-artist-sub-blocked {
        color: #646464;
        font-size: 18px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        margin-left: 10px;
    }
    .artist-sub-btn {
        background: #cdeb09;
        border-radius: 100px;
        padding: 11px 30px 12px 30px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        margin-top: 25px;
        border: none;
    }
    .venue-sub-btn {
        background: #ba87ff;
        border-radius: 100px;
        padding: 11px 30px 12px 30px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        margin-top: 25px;
        border: none;
    }
    .artist-sub-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .artist-ven-footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .artist-sub-exp {
        margin-top: 25px;
        border: none;
        background: none;
        color: #8b8b8b;
        text-align: center;
        font-size: 16px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .header-btn {
        display: flex;
        gap: 12px;
    }

    @media (max-width: 900px) {
        .info-venues {
            padding-left: 0;
        }
        .artist-find {
            max-width: 100%;
        }
        .promote-info {
            margin-left: 0;
            max-width: 100%;
            padding: 0 16px;
        }
        .goals-text-lil {
            max-width: 100%;
        }
        .hedlyner-text {
            font-size: 56px;
        }
        .hedlyner-goals {
            padding: 50px 16px;
        }
        .goals-text {
            font-size: 32px;
        }
        .artist-content-top {
            padding: 0 16px;
            margin-top: 128px;
        }
        .artist-find-btn {
            max-width: 100%;
        }
        .comment-container {
            min-width: 320px;
            padding: 0 16px;
            align-items: center;
        }
        .hedl-for-artists {
            display: block;
        }
        .header-btn {
            flex-direction: column;
        }
        .top-text-venue {
            padding: 0 16px;
            margin-top: 128px;
            margin-bottom: 20px;
        }
        .explore-venue-btn {
            max-width: 100%;
        }
        .venue-story {
            margin-left: 0;
            gap: 48px;
        }
        .acc-create-btn {
            margin-right: 0;
        }
        .for-bookers {
            display: block;
            margin-right: 0;
            flex: 0 1 100%;
        }
        .get-started {
            margin: 0 16px;
        }
        .subscr-plans {
            padding: 0 16px 128px 16px;
        }
        .sub-for-artist {
            min-width: 320px;
        }
        .sub-for-venue {
            min-width: 320px;
        }
    }
</style>
